import React, { Component } from 'react';
import axios from 'axios';
import { Grid, Card, CardContent, Box } from '@material-ui/core';
import RegionSelect from './RegionSelect';
import DistrictSelect from './DistrictSelect';
import RegionTable from './RegionTable';
import Quantity from './Quantity';
import JoiningExcelExport from '../buttons/JoiningExcelExport';
import { getNormalizedArray } from '../functions/array-functions';

class ConnectedCommunities extends Component {
  state = {
    array: null,
    regions: null,
    region: '',
    count: 0,
    districts: null,
    district: '',
    communities: null,
    error: null,
  };

  getCommunitiesByDistrict = (district) => {
    const { array, region } = this.state;

    if (!array || !region || !district) return null;

    const districtsByRegion = array.find((regionItem) => regionItem.regionName === region).districts;

    const communitiesByDistrict = districtsByRegion.find((districtItem) => districtItem.districtName === district)
      .communities;

    const info = communitiesByDistrict.reduce((acc, community) => {
      return [...acc, community];
    }, []);

    return info;
  };

  countCommunitiesInRegion = (districtsArray) => {
    return districtsArray.reduce((acc, districtObj) => {
      return (acc += districtObj.communities.length);
    }, 0);
  };

  getListOfDistrictsByRegion = (region) => {
    const { array } = this.state;

    if (!region) return;

    // find array of districts in one region
    const arrayOfDistricts = array.find((item) => item.regionName === region).districts;

    const listOfDistricts = [];

    arrayOfDistricts.forEach((district) => listOfDistricts.push(district.districtName));

    this.setState({ districts: listOfDistricts, count: this.countCommunitiesInRegion(arrayOfDistricts) });
  };

  // find regional object
  getRegionObject = (region) => {
    const { array } = this.state;
    return array.find((item) => item.regionName === region);
  };

  // all communities in one region
  getRegionalCommunities = (regionItem) => {
    const total = [];
    regionItem.districts.forEach((district) => {
      total.push(...district.communities);
    });
    return total;
  };

  handleRegionChange = (e) => {
    const region = e.target.textContent;
    this.setState({ region, districts: null, district: '', count: 0, communities: null });

    if (region) {
      this.getListOfDistrictsByRegion(region);
      const obj = this.getRegionObject(region);
      this.setState({ communities: this.getRegionalCommunities(obj) });
    }
  };

  handleDistrictChange = (e) => {
    const { region } = this.state;
    const district = e.target.textContent;
    let communities;
    if (district) communities = this.getCommunitiesByDistrict(district);
    else if (region) {
      const obj = this.getRegionObject(region);
      communities = this.getRegionalCommunities(obj);
    }

    this.setState({ district, communities });
  };

  async componentDidMount() {
    try {
      const data = await axios.get('/stat/allconn');
      const arrayOfRegions = data.data;
      // console.log('array', JSON.stringify(arrayOfRegions));
      let array = getNormalizedArray(arrayOfRegions);
      const listOfRegions = array.map((region) => region.regionName);
      this.setState({ array, regions: listOfRegions });
    } catch (error) {
      this.setState({ error });
    }
  }

  render() {
    const { array, regions, districts, district, count, communities, error } = this.state;

    const communityQuantity = district && communities ? <Quantity number={communities.length} size="small" /> : null;

    const centered = { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' };

    if (error) return null;

    return (
      <Card>
        <Box width="100%">
          <CardContent style={{ minWidth: '100%', border: '1px solid #283f71' }}>
            <Grid container direction="column">
              <Grid item xs={12}>
                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={12} style={centered}>
                    <h3 style={{ color: '#2B4458', marginBottom: '50px', textAlign: 'center' }}>
                      Приєднані ТГ у регіональному вимірі
                    </h3>
                  </Grid>
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={12} style={centered}>
                    <JoiningExcelExport dataSet={array} />
                  </Grid>
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={12} style={centered}>
                    <h4 style={{ color: '#3C4858' }}>Виберіть область:</h4>
                  </Grid>
                </Grid>
              </Grid>

              {/* Select and Circle 1 */}
              <Grid container direction="row" justify="center" alignItems="flex-start">
                <Grid item xs={12} sm={9}>
                  <RegionSelect array={regions} handleRegionChange={this.handleRegionChange} />
                </Grid>

                <Grid item xs={12} sm={3} style={centered}>
                  <Quantity number={count} size="big" />
                </Grid>
              </Grid>

              <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={12} style={centered}>
                  <h4 style={{ color: '#3C4858' }}>Виберіть район:</h4>
                </Grid>
              </Grid>

              {/* Select and Circle 2 */}
              <Grid container direction="row" justify="center" alignItems="center" style={{ marginBottom: '30px' }}>
                <Grid item xs={12} sm={9}>
                  <DistrictSelect array={districts} value={district} handleDistrictChange={this.handleDistrictChange} />
                </Grid>
                <Grid item xs={12} sm={3} style={centered}>
                  {communityQuantity}
                </Grid>
              </Grid>

              <Grid container spacing={3} justify="center">
                <Grid item xs={12}>
                  <RegionTable communities={communities} />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </Card>
    );
  }
}

export default ConnectedCommunities;
